import { Datatable, SearchHeader, SubHeader } from "../../../../common";
import { deleteBranch, getBranches } from "../../../../../api";
import { useLanguage } from "../../../../../context";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../../../Libraries";
import { useEffect, useState } from "react";

const LocationList = () => {
    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        resultsPerPage: 10,
        totalCount: 0,
        page: 1,
    });

    useEffect(() => {
        handleLocations();
    }, []);

    const onDelete = async (id) => {
        try {
            const data = await deleteBranch(id, { archive: true });
            if (data.success) handleLocations();
        } catch (err) { }
    };

    const handleLocations = async (reqPage = 1, filters = undefined) => {
        try {
            setLoading(true);

            let params = {
                resultsPerPage: pagination.resultsPerPage,
                page: reqPage
            };

            if (filters) params = { ...params, ...filters };

            const { data } = await getBranches(params);
            const { resultsPerPage, totalCount, branches, page } = data || {};

            setPagination({ resultsPerPage, totalCount, page });
            setList(branches.map(branch => {
                return {
                    address: branch?.address || '',
                    createdAt: branch.createdAt,
                    phone: branch?.phone || '',
                    code: branch?.code || '',
                    name: branch.name || '',
                    _id: branch._id,
                }
            }));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (page) => {
        if (page == pagination.current || loading) return;
        handleLocations(page);
    };

    const AddLocation = () => navigate('/location/create');

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        subTitle: 'manage_ur_locations',
                        title: 'location_list',
                        overlays: [
                            {
                                svg: 'assets/img/icons/pdf.svg',
                                tipType: I18n.pdf
                            },
                            {
                                svg: 'assets/img/icons/excel.svg',
                                tipType: I18n.excel
                            },
                            {
                                onClick: handleLocations,
                                Icon: Icon['referesh'],
                                tipType: I18n.refresh,
                                disabled: loading
                            }
                        ],
                        actions: [
                            {
                                className: 'btn btn-added',
                                title: 'add_new_location',
                                action: AddLocation,
                                icon: 'plus',

                            }
                        ],
                    }}
                />

                <div className="card table-list-card">
                    <div className="card-body">
                        <SearchHeader applyFilter={handleLocations} />

                        <div className="table-responsive">
                            <Datatable
                                onPageChange={onPageChange}
                                pagination={pagination}
                                onDelete={onDelete}
                                loading={loading}
                                dataSource={list}
                                noOfColumns={5}
                                type="location"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LocationList;